import {useCallback} from "react";
import {useToast} from "use-toast-mui";

export const useHandleCopy = () => {
    const toast = useToast();

    const handleCopy = useCallback(async (value: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(value);
            toast.info("Copied to clipboard!");
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    }, [toast])

    return {handleCopy}
}
